export const qkBaseFactor = ['factors']

//getWhiteLabel
export const qkGetWhiteLabel = () => [...qkBaseFactor, 'whiteLabels']

//getFactorSettings
export const qkGetFactorSettings = (factorId?: string | null) => [...qkBaseFactor, 'settings', factorId]

export const qkGetFactorMeTimezone = () => [...qkBaseFactor, 'me', 'timezone']

export const qkGetFactorFundingChargeback = () => [...qkBaseFactor, 'me', 'funding-chargeback']

//getFactorAccounts
export const qkGetFactorAccounts = () => [...qkBaseFactor, 'me', 'accounts']

//getFeatureFlags
export const qkGetFeatureFlags = () => [...qkBaseFactor, 'feature-flags']

//getFactorConfiguration
export const qkGetFactorConfiguration = () => [...qkBaseFactor, 'me', 'configuration']

//getChangelogFactor
type GetChangelogFactorListParams = {
  factorId: string
  searchValue?: string
  currentPage?: number
  paginationLimit?: number
  category?: string
}
export const qkGetFactorChangelog = (params: GetChangelogFactorListParams) => [
  ...qkBaseFactor,
  'changelog',
  params.factorId,
  params.searchValue,
  params.currentPage,
  params.paginationLimit,
  params.category,
]
